/**
 * O 1º gesto da aba — parte D1 (01/10/2026). O navegador só libera áudio depois de um
 * clique/toque/tecla; é nesse momento que o contexto de áudio nasce/retoma e a aba passa
 * a concorrer à vez de tocar. Uma vez só: o 1º `pointerup` OU `keydown` dispara e os
 * dois ouvintes saem. Fase de captura: um `stopPropagation` de algum componente não o
 * esconde.
 *
 * ⚠️ `pointerup`, não `pointerdown`: pela regra "activation triggering input event" do
 *    HTML, o `pointerdown` só ativa a página com o mouse; no toque ativa o
 *    `pointerup`/`touchend`. Como os ouvintes saem no 1º disparo, um toque que rodasse a
 *    ação cedo demais (antes da ativação) nunca teria 2ª chance e o som não destravaria
 *    no celular. O `Escape` não ativa a página, então não conta.
 */
export function aoPrimeiroGesto(acao: () => void): () => void {
  let feito = false;
  function remover() {
    window.removeEventListener("pointerup", disparar, true);
    window.removeEventListener("keydown", disparar, true);
  }
  function disparar(evento: Event) {
    if (feito) return;
    if (evento instanceof KeyboardEvent && evento.key === "Escape") return;
    feito = true;
    remover();
    try {
      acao();
    } catch (erro) {
      // o gesto da pessoa segue; o erro vai para o console
      console.warn("[avisos] falha na ação do 1º gesto", erro);
    }
  }
  window.addEventListener("pointerup", disparar, true);
  window.addEventListener("keydown", disparar, true);
  return remover;
}
